import { ReactComponent as LoginRegisterBG } from "../../assets/images/login-register-bg.svg";

// import AuthNavbar from "./AuthNavbar";

function Container(props) {
    const { children } = props;

    return (
        <>
            {/*<AuthNavbar />*/}
            <div className="h-screen w-full grid grid-flow-col md:grid-cols-5 xl:grid-cols-7 2xl:grid-cols-5">
                <div
                    className={
                        "flex items-center h-full  md:col-span-full " +
                        "lg:col-span-full lg:col-start-1 xl:col-span-5 xl:col-start-2 2xl:col-span-3 " +
                        "2xl:col-start-2 p-4 md:p-6"
                    }
                >
                    <div className="rounded-lg w-full overflow-hidden z-10 shadow-sm bg-white">
                        <div className="lg:flex w-full">{children}</div>
                    </div>
                    <LoginRegisterBG
                        className="opacity-10 absolute z-0 h-screen"
                        style={{
                            height: 600,
                            bottom: 0,
                            width: 800,
                            right: -0,
                        }}
                    />
                </div>
            </div>
        </>
    );
}

export default Container;
